<script>
  import { DonutChart } from "@carbon/charts-svelte";
  import { BarChartStacked } from "@carbon/charts-svelte";
  import entries from "../public/raw.json";

  const winners = entries.filter((pa) => pa.won);
  const losers = entries.filter((pa) => !pa.won);
  const getByBelief = (belief) => entries.filter((pa) => pa.believes == belief);

  const winnerLoserDonutData = [
    { value: winners.length, group: "Winners" },
    { value: losers.length, group: "Losers" },
  ];

  const winnerLoserDonutOptions = {
    title: "Winners and Losers",
    resizable: true,
    donut: {
      center: {
        label: "Participants",
      },
    },
    height: "400px",
  };

  const beliefDonutData = [
    { value: getByBelief("believes:yes").length, group: "Believers" },
    { value: getByBelief("believes:no").length, group: "Non-believers" },
    { value: getByBelief("believes:noIdea").length, group: "No idea" },
    {
      value: getByBelief("believes:yesNotSure").length,
      group: "Skeptic believer",
    },
    {
      value: getByBelief("believes:noNotSure").length,
      group: "Skeptic non-believer",
    },
  ];

  const beliefDonutOptions = {
    title: "Beliefs",
    resizable: true,
    donut: {
      center: {
        label: "Participants",
      },
    },
    height: "400px",
  };

  const byBeliefStackedData = [
    {
      group: "Winners",
      key: "Believers",
      value: getByBelief("believes:yes").filter((pa) => pa.won).length,
    },
    {
      group: "Losers",
      key: "Believers",
      value: getByBelief("believes:yes").filter((pa) => !pa.won).length,
    },
    {
      group: "Winners",
      key: "Non-Believers",
      value: getByBelief("believes:no").filter((pa) => pa.won).length,
    },
    {
      group: "Losers",
      key: "Non-Believers",
      value: getByBelief("believes:no").filter((pa) => !pa.won).length,
    },
    {
      group: "Winners",
      key: "No Idea",
      value: getByBelief("believes:noIdea").filter((pa) => pa.won).length,
    },
    {
      group: "Losers",
      key: "No Idea",
      value: getByBelief("believes:noIdea").filter((pa) => !pa.won).length,
    },
    {
      group: "Winners",
      key: "Skeptic believer",
      value: getByBelief("believes:yesNotSure").filter((pa) => pa.won).length,
    },
    {
      group: "Losers",
      key: "Skeptic believer",
      value: getByBelief("believes:yesNotSure").filter((pa) => !pa.won).length,
    },
    {
      group: "Winners",
      key: "Skeptic non-believer",
      value: getByBelief("believes:noNotSure").filter((pa) => pa.won).length,
    },
    {
      group: "Losers",
      key: "Skeptic non-believer",
      value: getByBelief("believes:noNotSure").filter((pa) => !pa.won).length,
    },
  ];

  const byBeliefStackedOptions = {
    title: "Metrics by belief",
    axes: {
      left: {
        mapsTo: "value",
        stacked: true,
      },
      bottom: {
        mapsTo: "key",
        scaleType: "labels",
      },
    },
    height: "400px",
  };

  const byBeliefPercentageStackedData = [
    {
      group: "Winners",
      key: "Believers",
      value:
        (getByBelief("believes:yes").filter((pa) => pa.won).length /
          getByBelief("believes:yes").length) *
        100,
    },
    {
      group: "Losers",
      key: "Believers",
      value:
        (getByBelief("believes:yes").filter((pa) => !pa.won).length /
          getByBelief("believes:yes").length) *
        100,
    },
    {
      group: "Winners",
      key: "Non-Believers",
      value:
        (getByBelief("believes:no").filter((pa) => pa.won).length /
          getByBelief("believes:no").length) *
        100,
    },
    {
      group: "Losers",
      key: "Non-Believers",
      value:
        (getByBelief("believes:no").filter((pa) => !pa.won).length /
          getByBelief("believes:no").length) *
        100,
    },
    {
      group: "Winners",
      key: "No Idea",
      value:
        (getByBelief("believes:noIdea").filter((pa) => pa.won).length /
          getByBelief("believes:noIdea").length) *
        100,
    },
    {
      group: "Losers",
      key: "No Idea",
      value:
        (getByBelief("believes:noIdea").filter((pa) => !pa.won).length /
          getByBelief("believes:noIdea").length) *
        100,
    },
    {
      group: "Winners",
      key: "Skeptic believer",
      value:
        (getByBelief("believes:yesNotSure").filter((pa) => pa.won).length /
          getByBelief("believes:yesNotSure").length) *
        100,
    },
    {
      group: "Losers",
      key: "Skeptic believer",
      value:
        (getByBelief("believes:yesNotSure").filter((pa) => !pa.won).length /
          getByBelief("believes:yesNotSure").length) *
        100,
    },
    {
      group: "Winners",
      key: "Skeptic non-believer",
      value:
        (getByBelief("believes:noNotSure").filter((pa) => pa.won).length /
          getByBelief("believes:noNotSure").length) *
        100,
    },
    {
      group: "Losers",
      key: "Skeptic non-believer",
      value:
        (getByBelief("believes:noNotSure").filter((pa) => !pa.won).length /
          getByBelief("believes:noNotSure").length) *
        100,
    },
  ];

  const byBeliefPercentageStackedOptions = {
    title: "Metrics by belief (percentage)",
    axes: {
      left: {
        mapsTo: "value",
        stacked: true,
      },
      bottom: {
        mapsTo: "key",
        scaleType: "labels",
      },
    },
    height: "400px",
  };

  const byShownStackedData = [
    {
      group: "Winners",
      key: "Revealed",
      value: entries.filter((pa) => pa.reveal).filter((pa) => pa.won).length,
    },
    {
      group: "Losers",
      key: "Revealed",
      value: entries.filter((pa) => pa.reveal).filter((pa) => !pa.won).length,
    },
    {
      group: "Winners",
      key: "Not revealed",
      value: entries.filter((pa) => !pa.reveal).filter((pa) => pa.won).length,
    },
    {
      group: "Losers",
      key: "Not revealed",
      value: entries.filter((pa) => !pa.reveal).filter((pa) => !pa.won).length,
    },
  ];

  const byShownStackedOptions = {
    title: "Metrics by answers revealed",
    axes: {
      left: {
        mapsTo: "value",
        stacked: true,
      },
      bottom: {
        mapsTo: "key",
        scaleType: "labels",
      },
    },
    height: "400px",
  };

  const byShownPercentageStackedData = [
    {
      group: "Winners",
      key: "Revealed",
      value:
        (entries.filter((pa) => pa.reveal).filter((pa) => pa.won).length /
          entries.filter((pa) => pa.reveal).length) *
        100,
    },
    {
      group: "Losers",
      key: "Revealed",
      value:
        (entries.filter((pa) => pa.reveal).filter((pa) => !pa.won).length /
          entries.filter((pa) => pa.reveal).length) *
        100,
    },
    {
      group: "Winners",
      key: "Not revealed",
      value:
        (entries.filter((pa) => !pa.reveal).filter((pa) => pa.won).length /
          entries.filter((pa) => !pa.reveal).length) *
        100,
    },
    {
      group: "Losers",
      key: "Not revealed",
      value:
        (entries.filter((pa) => !pa.reveal).filter((pa) => !pa.won).length /
          entries.filter((pa) => !pa.reveal).length) *
        100,
    },
  ];

  const byShownPercentageStackedOptions = {
    title: "Metrics by answers revealed (Percentage)",
    axes: {
      left: {
        mapsTo: "value",
        stacked: true,
      },
      bottom: {
        mapsTo: "key",
        scaleType: "labels",
      },
    },
    height: "400px",
  };

  const byBeliefRevealedStackedData = [
    {
      group: "Winners",
      key: "Believers",
      value: getByBelief("believes:yes")
        .filter((pa) => pa.reveal)
        .filter((pa) => pa.won).length,
    },
    {
      group: "Losers",
      key: "Believers",
      value: getByBelief("believes:yes")
        .filter((pa) => pa.reveal)
        .filter((pa) => !pa.won).length,
    },
    {
      group: "Winners",
      key: "Non-Believers",
      value: getByBelief("believes:no")
        .filter((pa) => pa.reveal)
        .filter((pa) => pa.won).length,
    },
    {
      group: "Losers",
      key: "Non-Believers",
      value: getByBelief("believes:no")
        .filter((pa) => pa.reveal)
        .filter((pa) => !pa.won).length,
    },
    {
      group: "Winners",
      key: "No Idea",
      value: getByBelief("believes:noIdea")
        .filter((pa) => pa.reveal)
        .filter((pa) => pa.won).length,
    },
    {
      group: "Losers",
      key: "No Idea",
      value: getByBelief("believes:noIdea")
        .filter((pa) => pa.reveal)
        .filter((pa) => !pa.won).length,
    },
    {
      group: "Winners",
      key: "Skeptic believer",
      value: getByBelief("believes:yesNotSure")
        .filter((pa) => pa.reveal)
        .filter((pa) => pa.won).length,
    },
    {
      group: "Losers",
      key: "Skeptic believer",
      value: getByBelief("believes:yesNotSure")
        .filter((pa) => pa.reveal)
        .filter((pa) => !pa.won).length,
    },
    {
      group: "Winners",
      key: "Skeptic non-believer",
      value: getByBelief("believes:noNotSure")
        .filter((pa) => pa.reveal)
        .filter((pa) => pa.won).length,
    },
    {
      group: "Losers",
      key: "Skeptic non-believer",
      value: getByBelief("believes:noNotSure")
        .filter((pa) => pa.reveal)
        .filter((pa) => !pa.won).length,
    },
  ];

  const byBeliefRevealedStackedOptions = {
    title: "Metrics by belief (Revealed)",
    axes: {
      left: {
        mapsTo: "value",
        stacked: true,
      },
      bottom: {
        mapsTo: "key",
        scaleType: "labels",
      },
    },
    height: "400px",
  };

  const byBeliefRevealedPercentageStackedData = [
    {
      group: "Winners",
      key: "Believers",
      value:
        (getByBelief("believes:yes")
          .filter((pa) => pa.reveal)
          .filter((pa) => pa.won).length /
          getByBelief("believes:yes").filter((pa) => pa.reveal).length) *
        100,
    },
    {
      group: "Losers",
      key: "Believers",
      value:
        (getByBelief("believes:yes")
          .filter((pa) => pa.reveal)
          .filter((pa) => !pa.won).length /
          getByBelief("believes:yes").filter((pa) => pa.reveal).length) *
        100,
    },
    {
      group: "Winners",
      key: "Non-Believers",
      value:
        (getByBelief("believes:no")
          .filter((pa) => pa.reveal)
          .filter((pa) => pa.won).length /
          getByBelief("believes:no").filter((pa) => pa.reveal).length) *
        100,
    },
    {
      group: "Losers",
      key: "Non-Believers",
      value:
        (getByBelief("believes:no")
          .filter((pa) => pa.reveal)
          .filter((pa) => !pa.won).length /
          getByBelief("believes:no").filter((pa) => pa.reveal).length) *
        100,
    },
    {
      group: "Winners",
      key: "No Idea",
      value:
        (getByBelief("believes:noIdea")
          .filter((pa) => pa.reveal)
          .filter((pa) => pa.won).length /
          getByBelief("believes:noIdea").filter((pa) => pa.reveal).length) *
        100,
    },
    {
      group: "Losers",
      key: "No Idea",
      value:
        (getByBelief("believes:noIdea")
          .filter((pa) => pa.reveal)
          .filter((pa) => !pa.won).length /
          getByBelief("believes:noIdea").filter((pa) => pa.reveal).length) *
        100,
    },
    {
      group: "Winners",
      key: "Skeptic believer",
      value:
        (getByBelief("believes:yesNotSure")
          .filter((pa) => pa.reveal)
          .filter((pa) => pa.won).length /
          getByBelief("believes:yesNotSure").filter((pa) => pa.reveal).length) *
        100,
    },
    {
      group: "Losers",
      key: "Skeptic believer",
      value:
        (getByBelief("believes:yesNotSure")
          .filter((pa) => pa.reveal)
          .filter((pa) => !pa.won).length /
          getByBelief("believes:yesNotSure").filter((pa) => pa.reveal).length) *
        100,
    },
    {
      group: "Winners",
      key: "Skeptic non-believer",
      value:
        (getByBelief("believes:noNotSure")
          .filter((pa) => pa.reveal)
          .filter((pa) => pa.won).length /
          getByBelief("believes:noNotSure").filter((pa) => pa.reveal).length) *
        100,
    },
    {
      group: "Losers",
      key: "Skeptic non-believer",
      value:
        (getByBelief("believes:noNotSure")
          .filter((pa) => pa.reveal)
          .filter((pa) => !pa.won).length /
          getByBelief("believes:noNotSure").filter((pa) => pa.reveal).length) *
        100,
    },
  ];

  const byBeliefRevealedPercentageStackedOptions = {
    title: "Metrics by belief (Revealed) (Percentage)",
    axes: {
      left: {
        mapsTo: "value",
        stacked: true,
      },
      bottom: {
        mapsTo: "key",
        scaleType: "labels",
      },
    },
    height: "400px",
  };

  const byBeliefNotRevealedStackedData = [
    {
      group: "Winners",
      key: "Believers",
      value: getByBelief("believes:yes")
        .filter((pa) => !pa.reveal)
        .filter((pa) => pa.won).length,
    },
    {
      group: "Losers",
      key: "Believers",
      value: getByBelief("believes:yes")
        .filter((pa) => !pa.reveal)
        .filter((pa) => !pa.won).length,
    },
    {
      group: "Winners",
      key: "Non-Believers",
      value: getByBelief("believes:no")
        .filter((pa) => !pa.reveal)
        .filter((pa) => pa.won).length,
    },
    {
      group: "Losers",
      key: "Non-Believers",
      value: getByBelief("believes:no")
        .filter((pa) => !pa.reveal)
        .filter((pa) => !pa.won).length,
    },
    {
      group: "Winners",
      key: "No Idea",
      value: getByBelief("believes:noIdea")
        .filter((pa) => !pa.reveal)
        .filter((pa) => pa.won).length,
    },
    {
      group: "Losers",
      key: "No Idea",
      value: getByBelief("believes:noIdea")
        .filter((pa) => !pa.reveal)
        .filter((pa) => !pa.won).length,
    },
    {
      group: "Winners",
      key: "Skeptic believer",
      value: getByBelief("believes:yesNotSure")
        .filter((pa) => !pa.reveal)
        .filter((pa) => pa.won).length,
    },
    {
      group: "Losers",
      key: "Skeptic believer",
      value: getByBelief("believes:yesNotSure")
        .filter((pa) => !pa.reveal)
        .filter((pa) => !pa.won).length,
    },
    {
      group: "Winners",
      key: "Skeptic non-believer",
      value: getByBelief("believes:noNotSure")
        .filter((pa) => !pa.reveal)
        .filter((pa) => pa.won).length,
    },
    {
      group: "Losers",
      key: "Skeptic non-believer",
      value: getByBelief("believes:noNotSure")
        .filter((pa) => !pa.reveal)
        .filter((pa) => !pa.won).length,
    },
  ];

  const byBeliefNotRevealedStackedOptions = {
    title: "Metrics by belief (Not revealed)",
    axes: {
      left: {
        mapsTo: "value",
        stacked: true,
      },
      bottom: {
        mapsTo: "key",
        scaleType: "labels",
      },
    },
    height: "400px",
  };

  const byBeliefNotRevealedPercentageStackedData = [
    {
      group: "Winners",
      key: "Believers",
      value:
        (getByBelief("believes:yes")
          .filter((pa) => !pa.reveal)
          .filter((pa) => pa.won).length /
          getByBelief("believes:yes").filter((pa) => !pa.reveal).length) *
        100,
    },
    {
      group: "Losers",
      key: "Believers",
      value:
        (getByBelief("believes:yes")
          .filter((pa) => !pa.reveal)
          .filter((pa) => !pa.won).length /
          getByBelief("believes:yes").filter((pa) => !pa.reveal).length) *
        100,
    },
    {
      group: "Winners",
      key: "Non-Believers",
      value:
        (getByBelief("believes:no")
          .filter((pa) => !pa.reveal)
          .filter((pa) => pa.won).length /
          getByBelief("believes:no").filter((pa) => !pa.reveal).length) *
        100,
    },
    {
      group: "Losers",
      key: "Non-Believers",
      value:
        (getByBelief("believes:no")
          .filter((pa) => !pa.reveal)
          .filter((pa) => !pa.won).length /
          getByBelief("believes:no").filter((pa) => !pa.reveal).length) *
        100,
    },
    {
      group: "Winners",
      key: "No Idea",
      value:
        (getByBelief("believes:noIdea")
          .filter((pa) => !pa.reveal)
          .filter((pa) => pa.won).length /
          getByBelief("believes:noIdea").filter((pa) => !pa.reveal).length) *
        100,
    },
    {
      group: "Losers",
      key: "No Idea",
      value:
        (getByBelief("believes:noIdea")
          .filter((pa) => !pa.reveal)
          .filter((pa) => !pa.won).length /
          getByBelief("believes:noIdea").filter((pa) => !pa.reveal).length) *
        100,
    },
    {
      group: "Winners",
      key: "Skeptic believer",
      value:
        (getByBelief("believes:yesNotSure")
          .filter((pa) => !pa.reveal)
          .filter((pa) => pa.won).length /
          getByBelief("believes:yesNotSure").filter((pa) => !pa.reveal)
            .length) *
        100,
    },
    {
      group: "Losers",
      key: "Skeptic believer",
      value:
        (getByBelief("believes:yesNotSure")
          .filter((pa) => !pa.reveal)
          .filter((pa) => !pa.won).length /
          getByBelief("believes:yesNotSure").filter((pa) => !pa.reveal)
            .length) *
        100,
    },
    {
      group: "Winners",
      key: "Skeptic non-believer",
      value:
        (getByBelief("believes:noNotSure")
          .filter((pa) => !pa.reveal)
          .filter((pa) => pa.won).length /
          getByBelief("believes:noNotSure").filter((pa) => !pa.reveal).length) *
        100,
    },
    {
      group: "Losers",
      key: "Skeptic non-believer",
      value:
        (getByBelief("believes:noNotSure")
          .filter((pa) => !pa.reveal)
          .filter((pa) => !pa.won).length /
          getByBelief("believes:noNotSure").filter((pa) => !pa.reveal).length) *
        100,
    },
  ];

  const byBeliefNotRevealedPercentageStackedOptions = {
    title: "Metrics by belief (Not revealed) (Percentage)",
    axes: {
      left: {
        mapsTo: "value",
        stacked: true,
      },
      bottom: {
        mapsTo: "key",
        scaleType: "labels",
      },
    },
    height: "400px",
  };
</script>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://unpkg.com/@carbon/charts/styles.min.css"
  />
</svelte:head>

<main>
  <section>
    <div class="chart">
      <DonutChart
        data={winnerLoserDonutData}
        options={winnerLoserDonutOptions}
      />
    </div>
    <div class="chart">
      <DonutChart data={beliefDonutData} options={beliefDonutOptions} />
    </div>
    <div class="chart">
      <BarChartStacked
        data={byBeliefStackedData}
        options={byBeliefStackedOptions}
      />
    </div>
    <div class="chart">
      <BarChartStacked
        data={byBeliefPercentageStackedData}
        options={byBeliefPercentageStackedOptions}
      />
    </div>
    <div class="chart">
      <BarChartStacked
        data={byShownStackedData}
        options={byShownStackedOptions}
      />
    </div>
    <div class="chart">
      <BarChartStacked
        data={byShownPercentageStackedData}
        options={byShownPercentageStackedOptions}
      />
    </div>
    <div class="chart">
      <BarChartStacked
        data={byBeliefRevealedStackedData}
        options={byBeliefRevealedStackedOptions}
      />
    </div>
    <div class="chart">
      <BarChartStacked
        data={byBeliefRevealedPercentageStackedData}
        options={byBeliefRevealedPercentageStackedOptions}
      />
    </div>
    <div class="chart">
      <BarChartStacked
        data={byBeliefNotRevealedStackedData}
        options={byBeliefNotRevealedStackedOptions}
      />
    </div>
    <div class="chart">
      <BarChartStacked
        data={byBeliefNotRevealedPercentageStackedData}
        options={byBeliefNotRevealedPercentageStackedOptions}
      />
    </div>
    <div class="buttons">
      <a href="/raw.json" download> Raw data </a>
    </div>
  </section>
</main>

<style>
  main {
    padding: 1em;
  }
  section {
    display: flex;
    flex-wrap: wrap;
    gap: 5em 10em;
    max-width: 960px;
    margin: 0 auto;
    align-items: center;
    justify-content: center;
  }
  .buttons {
    padding-bottom: 2em;
  }
  .buttons a {
    border-radius: 8px;
    background: rgb(20, 30, 45);
    color: #fff;
    padding: 0.5em 1em;
    text-decoration: none;
  }
</style>
